import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, Instagram } from "lucide-react";
import { BRAND } from "../lib/brand";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="relative bg-brown-deep border-t border-border overflow-hidden">
      <div className="absolute inset-0 footprint-bg opacity-[0.04] pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 pt-16 pb-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <div
              data-testid="footer-parent-badge"
              className="inline-flex items-center gap-2 border border-orange/50 rounded-full px-3.5 py-1.5 mb-5"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-orange" />
              <span className="text-[11px] uppercase tracking-[0.22em] text-cream/80 font-bold">
                A <span className="text-orange">{BRAND.parent}</span> brand
              </span>
            </div>
            <p className="font-accent text-chick text-2xl mb-2">Hungry yet?</p>
            <h2 className="font-heading uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.85] tracking-tighter">
              Order your
              <br />
              <span className="text-orange">kukkad</span> now.
            </h2>
            <div className="flex flex-wrap gap-3 mt-8">
              <a
                data-testid="footer-whatsapp"
                href={BRAND.whatsapp}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 bg-orange text-primary-foreground font-bold uppercase text-sm px-6 py-3.5 rounded-md hover:scale-105 transition-transform"
              >
                <MessageCircle className="w-4 h-4" /> WhatsApp Order
              </a>
              <Link
                to="/menu"
                data-testid="footer-menu-cta"
                className="flex items-center gap-2 border border-cream/40 text-cream font-bold uppercase text-sm px-6 py-3.5 rounded-md hover:bg-cream hover:text-brown transition-colors"
              >
                Browse Menu
              </Link>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm uppercase tracking-widest text-cream/50 mb-4">Explore</h4>
            <ul className="space-y-2.5">
              {[
                ["/menu", "Menu"],
                ["/offers", "Offers & Combos"],
                ["/about", "About Us"],
                ["/reviews", "Reviews"],
                ["/blog", "The Journal"],
                ["/contact", "Contact"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-cream/80 hover:text-orange transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm uppercase tracking-widest text-cream/50 mb-4">Reach Us</h4>
            <ul className="space-y-3 text-cream/80">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 text-orange shrink-0" /> {BRAND.location}
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-orange shrink-0" />
                <a href={`tel:+91${BRAND.phone}`} className="hover:text-orange">{BRAND.phoneDisplay}</a>
              </li>
              <li className="flex items-center gap-2">
                <Instagram className="w-4 h-4 text-orange shrink-0" />
                <a href={BRAND.instagram} target="_blank" rel="noreferrer" className="hover:text-orange">@thekukkadco</a>
              </li>
            </ul>
            <div className="flex gap-2 mt-5">
              <a href={BRAND.zomato} target="_blank" rel="noreferrer" className="text-xs font-bold uppercase border border-cream/30 px-3 py-2 rounded hover:border-orange hover:text-orange transition-colors">Zomato</a>
              <a href={BRAND.swiggy} target="_blank" rel="noreferrer" className="text-xs font-bold uppercase border border-cream/30 px-3 py-2 rounded hover:border-orange hover:text-orange transition-colors">Swiggy</a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3 text-cream/50 text-sm">
          <p>© {new Date().getFullYear()} {BRAND.name} · A <span className="text-orange font-bold">{BRAND.parent}</span> brand</p>
          <p>{BRAND.domain}</p>
          <p className="text-xs">FSSAI Lic. No. 1234567890 · Made in Noida</p>
        </div>
      </div>
    </footer>
  );
}
